import { render, staticRenderFns } from "./phone.edit.vue?vue&type=template&id=55e595f6&scoped=true"
import script from "./phone.edit.vue?vue&type=script&lang=js"
export * from "./phone.edit.vue?vue&type=script&lang=js"
import style0 from "./phone.edit.vue?vue&type=style&index=0&id=55e595f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e595f6",
  null
  
)

export default component.exports